import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useCurrentCampaignYear } from '/@/hooks/zones';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import DashboardSubheader from '/@/views/dashboard/components/dashboard-sub-header';
import FieldMonitoringDashboardPastReports from '/@/views/fields/field-monitoring/dashboard/tabs/past-reports';
import { PastReportsDashboardCards } from '../../../../../growers/tabs/past-campaign';

const GrowerDashboardPastReports = ({ growerNodeId }: { growerNodeId: number }) => {
    const currentCampaignYear = useCurrentCampaignYear();
    const previousCampaignYear = useMemo(() => {
        return currentCampaignYear !== null ? currentCampaignYear - 1 : null;
    }, [currentCampaignYear]);
    const form = useForm<{
        year: number;
    }>({
        defaultValues: {
            year: previousCampaignYear ?? new Date().getFullYear() - 1,
        },
    });

    // Update form value when previousCampaignYear becomes available
    useEffect(() => {
        if (previousCampaignYear !== null) {
            form.setValue('year', previousCampaignYear);
        }
    }, [previousCampaignYear, form]);
    return (
        <>
            <DashboardSubheader
                title={_('Reportes de campaña')}
                subtitle={_(
                    'Accedé al resumen de resultados de los lotes para analizar el rendimiento y planificar la próxima campaña.'
                )}
                form={form}
            />
            <PastReportsDashboardCards
                year={form.watch('year')}
                growerNodeId={growerNodeId}
                isRv={false}
                nodeScope={getNodeScopeFilters('myFields')}
            />
            <FieldMonitoringDashboardPastReports
                growerNodeId={growerNodeId}
                year={form.watch('year')}
                nodeScope={getNodeScopeFilters('myFields')}
            />
        </>
    );
};

export default GrowerDashboardPastReports;
